// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"7e46c0e5","354":"3840a68a","364":"b45306da","373":"4f007993","481":"e18d3832","488":"371f7511","595":"190dcb51","601":"fa2e5f52","628":"40659ab9","776":"e067bad3"}[chunkId] + ".chunk.js";
};